import React, { useState } from 'react'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  // DialogActions,
  Button,
} from '@material-ui/core'
import {
//   Link,
// useNavigate,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@material-ui/core/styles'
import muiDefaultOptions from '../../constants/muiTableOptions'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import { selectUserInfo } from '../../app/slices/userSlice'
import { getAllCertificates, selectorCertificates } from '../../app/slices/courseSlice'

const CERTIFICATE_STATUS = {
  100: 'در حال پرداخت',
  101: 'پرداخت شده',
  102: 'ارسال شده',
  103: 'تحویل داده شده',
}

const useStyle = makeStyles((theme) => ({
  root: {
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
  valueCell: {
    color: '#000',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'right',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      // width: '587px',
      width: '50%',
      // height: '450px',
      height: 'auto',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#f9b233, #f8d495)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
}))

export const AdminCertificate = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { role } = useSelector(selectUserInfo)
  const certificates = useSelector(selectorCertificates)
  // const navigate = useNavigate()
  const [infoModal, setInfoModal] = useState(false)
  const [userInfo, setUserInfo] = useState({})

  React.useEffect(() => {
    if ([2, 3].includes(role?.roleId)) {
      dispatch(getAllCertificates())
    }
  }, [])

  const userCertificate = (id) => {
    const user = certificates?.find((item) => item?.id === id)
    setUserInfo(user)
    setInfoModal(true)
  }

  const COLUMNS = [
    {
      name: 'id',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (<p className={classes.valueCell}>{value}</p>),
      },
    },
    {
      name: 'user',
      label: 'نام کاربر',
      options: {
        sort: false,
        filter: false,
        customBodyRender(value, data) {
          console.log(data.rowData[0].name)
          return (
            <p className={classes.valueCell}>
              {value?.profile?.firstName}
              {' '}
              {value?.profile?.lastName}
            </p>
          )
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ درخواست',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (
          <p className={classes.valueCell}>
            {value
              ? moment(value)?.format('jYYYY/jMM/jDD') : '--'}

          </p>
        ),
      },
    },
    {
      name: 'status',
      label: 'وضعیت پرداخت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (
          <p className={classes.valueCell}>
            {CERTIFICATE_STATUS[value]}

          </p>
        ),
      },
    },
    {
      name: 'certificate',
      label: 'نام دوره',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (
          <p className={classes.valueCell}>
            {value?.title}

          </p>
        ),
      },
    },
    {
      name: 'id',
      label: 'جزییات',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <div>
              <Button variant="contained" color="primary" onClick={() => userCertificate(value)}>جزییات بیشتر</Button>
            </div>
          )
        },
      },
    },
  ]

  const handleClose = () => {
    setInfoModal(false)
  }

  console.log('userInfo', userInfo)

  return (
    <Page
      className={classes.root}
      title="گواهینامه"
    >
      <Grid className={classes.root}>
        <Typography variant="h3" style={{ margin: '15px 0 20px' }} component="h3">فهرست گواهینامه ها</Typography>
        <ThemeProvider theme={getMuiThemeWithoutPadding}>
          <MUIDataTable
            data={certificates}
            columns={COLUMNS}
            options={{
              ...muiDefaultOptions,
              serverSide: true,
              filter: true,
              print: false,
              download: false,
              search: true,
              rowHover: true,
              // responsive: 'scroll',
              // selectableRowsHeader: true,
              // expandableRows: true,
              expandableRowsOnClick: true,
              selectableRows: 'none',
              searchable: true,
              sort: true,
              pagination: true,
              viewColumns: true,
            }}
          />
        </ThemeProvider>
      </Grid>
      <Dialog
        className={classes.deleteDialog}
        // style={{ width: '50%' }}
        open={infoModal}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">جزییات</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            نام:
            <br />
            {userInfo?.user?.profile?.firstName}
            {' '}
            {userInfo?.user?.profile?.lastName}
          </DialogContentText>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            شماره موبایل:
            <br />
            {userInfo?.user?.profile?.phoneNumber}
          </DialogContentText>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            نام دوره:
            <br />
            {userInfo?.certificate?.title}
          </DialogContentText>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            شهر:
            <br />
            {userInfo?.user?.profile?.province?.name}
          </DialogContentText>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            ادرس:
            <br />
            {userInfo?.userAddress?.address}
          </DialogContentText>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            کد پستی:
            <br />
            {userInfo?.userAddress?.postalCode}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Page>

  )
}

export default AdminCertificate
